module.exports = __webpack_public_path__ + "assets/d326c95958282a359e0cb1a251036bad.png";